import { render, staticRenderFns } from "./acknowledgement.vue?vue&type=template&id=57e62a9e&scoped=true"
import script from "./acknowledgement.vue?vue&type=script&lang=js"
export * from "./acknowledgement.vue?vue&type=script&lang=js"
import style0 from "./acknowledgement.vue?vue&type=style&index=0&id=57e62a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e62a9e",
  null
  
)

export default component.exports